module.exports = __webpack_public_path__ + "img/img14.44870a45.jpg";